import { TaskDto } from "../../../../dtos/task-dto";
import { PrioritiesEnum } from "../../../../dtos/priorities-enum";
import { ContextEnums } from "../../../../dtos/context-enums";
import { TaskTypeEnums } from "../../../../dtos/task-type-enums";
import { SelectOptions } from "../../../../dtos/select-options";
import { TasksConfigurationDto } from "../../../../dtos/tasks-configuration-dto";
import { ContextProps } from "../InsuredDrawerConstants";

export const getSaveButtonItems = (saveTaskWithStatus) => [
  {
    key: 1,
    option: "Save as Active",
    dropdownText: "Save Only",
    action: () => saveTaskWithStatus("Active"),
  },
  {
    key: 2,
    option: "Save as Complete",
    dropdownText: "Save as Complete",
    action: () => saveTaskWithStatus("Complete"),
  },
  {
    key: 3,
    option: "Save as Cancelled",
    dropdownText: "Cancel Task",
    action: () => saveTaskWithStatus("Cancelled"),
  },
  {
    key: 4,
    option: "Save as Deleted",
    dropdownText: "Deleted Task",
    action: () => saveTaskWithStatus("Deleted"),
  },
];

export const getTaskInBlank = (
  insuredId: number,
  taskStatus: number,
  currentUserId: number,
  contextType: number,
  adjusterId: number,
  claimNumber?: string
): TaskDto => {
  return {
    taskId: 0,
    insuredId: insuredId,
    claimNumber,
    claimId: 0,
    ownerUserId: currentUserId,
    assignedUserId:
      contextType === ContextEnums.CLAIMS ? adjusterId : currentUserId,
    taskStatus,
    subject: "",
    priority: PrioritiesEnum.MEDIUM,
    estTime: null,
    actualTime: null,
    comments: "",
  };
};

export const getTaskTypeFromContext = (contextType: number) => {
  return contextType === ContextEnums.CLAIMS
    ? TaskTypeEnums.CLAIM
    : TaskTypeEnums.POLICY;
};

export const getValueByDisplayValueFromSelectOptions = (
  key: any,
  selectOptions: SelectOptions[] | Partial<SelectOptions>[]
) => {
  const activeStatus = selectOptions.find(
    (status) => status.displayName === key
  );

  return activeStatus?.intValue ?? 0;
};

export const getNewTaskData = (
  taskConfiguration: TasksConfigurationDto | null,
  context: ContextProps,
  globalAtom: any
) => {
  const activeStatusId = getValueByDisplayValueFromSelectOptions(
    "Active",
    taskConfiguration?.taskStatusList ?? []
  );
  const currentUserId = globalAtom.userId;
  const insuredId = context.insuredId ?? 0;
  return getTaskInBlank(
    insuredId,
    activeStatusId,
    currentUserId,
    context.type,
    taskConfiguration?.currentClaimAdjusterId ?? 0,
    context.claimNumber
  );
};

export const getInitialTaskData = (
  statusList: Partial<SelectOptions>[],
  formState: any,
  taskConfiguration: TasksConfigurationDto | null,
  context: ContextProps,
  globalAtom: any
) => {
  const activeStatusId = getValueByDisplayValueFromSelectOptions(
    "Active",
    statusList
  );
  const currentUserId = globalAtom.userId;
  const insuredId = context.insuredId ?? 0;

  const initialTask =
    formState?.editData != null
      ? {
          ...formState?.editData,
          insuredId: insuredId,
          claimNumber: context?.claimNumber,
        }
      : getTaskInBlank(
          insuredId,
          activeStatusId,
          currentUserId,
          context.type,
          taskConfiguration?.currentClaimAdjusterId ?? 0,
          context.claimNumber
        );

  return {
    ...formState,
    editData: initialTask,
  };
};

export const getEmptyFilesInfoObject = () => {
  return {
    files: {},
    savedFiles: [],
    fileIds: [],
    tmpFiles: [],
    fileToDelete: undefined,
    clearFiles: false,
  };
};
